import {MatchmakingMatchTypes} from '@colonist/game-base-types'
import {PlayerColor} from '@colonist/game-states'
import {StateCreator} from 'zustand'

export interface GameDetailsSlice {
    gameDetails: {
        matchmakingMatchType: MatchmakingMatchTypes | undefined
        isRanked: boolean
        isDiscord: boolean
        playOrder: PlayerColor[]
        isCanvasFullWidth: boolean
    }
}

export interface GameDetailsSliceProps {
    matchmakingMatchType: MatchmakingMatchTypes | undefined
    isRanked: boolean
    isDiscord: boolean
    playOrder: PlayerColor[]
    isCanvasFullWidth: boolean
}

export const createGameDetailsSlice = (props: GameDetailsSliceProps): StateCreator<GameDetailsSlice> => (set, get) => ({
    gameDetails: {
        matchmakingMatchType: props.matchmakingMatchType,
        isRanked: props.isRanked,
        isDiscord: props.isDiscord,
        playOrder: props.playOrder,
        isCanvasFullWidth: props.isCanvasFullWidth,
    },
})
